import React from 'react';
import { KPICard } from '../../ui';
import { useSatisfactionBestShift } from '../../../hooks/useSatisfactionKPIs';
import LoadingSpinner from '../../ui/LoadingSpinner';
import { TimePeriod } from '../../../types/api';

import { KPIProps } from '../../../types/kpi';
const BestShiftKPI: React.FC<KPIProps> = ({
  branchId = 0,
  timeRange,
  onError,
  showLoading = true,
  compact = false,
  className = ''
}) => {
  const { data, isLoading, isError, error, refetch } = useSatisfactionBestShift(branchId, timeRange as TimePeriod);

  // Shift time range mapping (from API format to display name)
  const shiftMapping: Record<string, { name: string; displayRange: string }> = {
    '02:00 t 12:00': { name: 'صبح', displayRange: '02:00-12:00' },
    '12:00 t 16:00': { name: 'ظهر', displayRange: '12:00-16:00' },
    '16:00 t 20:00': { name: 'عصر', displayRange: '16:00-20:00' },
    '20:00 t 02:00': { name: 'شب', displayRange: '20:00-02:00' }
  };

  React.useEffect(() => {
    if (isError && error && onError) {
      onError(error as Error);
    }
  }, [isError, error, onError]);

  if (isLoading && showLoading) {
    return (
      <div className={`${className} animate-enter animate-delay-3`}>
        <div className="card-base card-padding">
          <div className="flex flex-col items-center justify-center h-32">
            <LoadingSpinner
              variant="minimal"
              size="md"
            />
          </div>
        </div>
      </div>
    );
  }

  if (isError || !data) {
    return (
      <div className={`${className} card-base border border-status-error p-4`}>
        <p className="text-status-error text-sm">خطا در بارگذاری بهترین شیفت</p>
        {showLoading && (
          <button
            onClick={() => refetch()}
            className="mt-2 text-xs text-primary-600 hover:text-primary-700"
          >
            تلاش مجدد
          </button>
        )}
      </div>
    );
  }

  const getVariant = (satisfaction: number) => {
    if (satisfaction >= 85) return 'success';
    if (satisfaction >= 70) return 'info';
    return 'warning';
  };

  const shiftInfo = shiftMapping[data.bestShift];
  const displayValue = shiftInfo 
    ? `${shiftInfo.name} (${shiftInfo.displayRange})`
    : data.bestShift; // Fallback to original value if not found in mapping
  
  return (
    <div className={`${className} animate-enter-up stagger-1`}>
      <KPICard
        title="بهترین شیفت کاری"
        value={displayValue}
        subtitle={`${data.bestShiftSatisfaction.toFixed(1)}%`}
        variant={getVariant(data.bestShiftSatisfaction)}
        accentStyle="corner"
      />
    </div>
  );
};

export default BestShiftKPI;